// extracted by mini-css-extract-plugin
module.exports = {"objectValue":"styles_objectValue__3m7X6","slightlySpaced":"styles_slightlySpaced__3otEX","label":"styles_label__1tXdF"};